<template>
  <div class="">
    <div class="">
      <section class="">
        <form @submit.prevent.stop="submit">
          <div class="columns is-multiline">
            <div class="column is-narrow">
              <span class="label">Recevoir les alertes par mail</span>
              <input id="mail_alert" type="checkbox" name="mail_alert" v-model="param.mail_alert"
                    class="switch is-success is-rounded is-medium">
              <label for="mail_alert"></label>
            </div>
            <div class="column is-narrow">
              <span class="label">Recevoir les alertes par SMS</span>
              <input id="sms_alert" type="checkbox" name="sms_alert" v-model="param.sms_alert"
                    class="switch is-success is-rounded is-medium">
              <label for="sms_alert"></label>
            </div>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ManageNotificationModal',
    data () {
      return {
        param: {}
      }
    },
    props: {
      source: {
        type: Object,
        required: true
      }
    },
    methods: {
      submit () {
        this.$api.currentUserService.patch(this.param).then(r => {
          this.$notify({
            type: 'is-success',
            text: 'Mise à jour effectuée.'
          })
          this.$store.commit('setCurrentUser', {user: r.data})
          this.$emit('submit', {user: r.data})
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la mise à jour.'
          })
        })
      }
    },
    created () {
      Object.assign(this.param, this.source)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/quickview/ManageNotificationModal.vue